import React from 'react'
import { Container, Row, Col, Button, FormGroup, Label } from 'reactstrap';
import { Field } from 'redux-form'


import { renderInput, renderInputUpperCase, renderSelect, renderRadio } from '../../utils/forms/renderers'
import { isRequired, exactLength, maxLength, minLength, isEmail } from '../../utils/forms/validators'
import Loader from '../../core/components/Loader'
import { ButtonLoader } from '../../utils/loader'
import '../styles/style.css';
import '../styles/form.css';


class FormStepTwo extends React.Component {

	constructor(props) {
        super(props);

        var year = new Array();
        for (var i = new Date().getFullYear(); i > 1900; i--) {
            year.push(Object({id:i, name:i}));
        }

        var day = new Array();
        for (var i = 1; i < 32; i++) {
            if(i > 9)
              day.push(Object({id:i, name:i}));
            else
              day.push(Object({id:"0"+i.toString(), name:i}));
        }

        this.state={
          responsive:false,
          year,
          day
        }
    }

    componentDidMount() {
      if( window.innerWidth < 520)
        this.setState({responsive:true})
    }

    renderContact(name, libelle){
      const { getValue } = this.props;

      return(
        <div>
          <Row>
              <Col>
                  <div className="separation"> </div>
              </Col>
          </Row>
          <Row>
              <Col>
                  <div className="title">Contact {libelle}</div>
              </Col>
          </Row>
          <Row>
              <Col>
                <FormGroup className="input-radio">
                    <Label>Partie réservée au responsable de région</Label>
                    <FormGroup check>
                        <Field
                          name={`${name}`}
                          type="radio"
                          component={renderRadio}
                          value="False"
                          label="Non"
                          onChange={(event) => console.log(event.target.value)} />
                          <Field
                          name={`${name}`}
                          type="radio"
                          value="True"
                          component={renderRadio}
                          label="Oui" />
                    </FormGroup>
                </FormGroup>
              </Col>
          </Row>
          {getValue[`${name}`] === "True" &&
            <div>
              <Row>
                  <Col>
                    <Field
                      name={`${name}`+"_name"}
                      component={renderInput}
                      validate={isRequired}
                      label="Nom complet*" />
                  </Col>
              </Row>
              <Row>
                  <Col>
                    <Field
                      name={`${name}`+"_phone"}
                      component={renderInput}
                      validate={[minLength(10)]}
                      maxlength="10"
                      label="Téléphone" />
                  </Col>
              </Row>
              <Row>
                  <Col>
                    <Field
                      name={`${name}`+"_email"}
                      type="email"
                      component={renderInput}
                      validate={[isEmail]}
                      label="Email" />
                  </Col>
              </Row>
              <Row>
                  <Col>
                    <Field
                      name={`${name}`+"_comment"}
                      component={renderInput}
                      label="Commentaire" />
                  </Col>
              </Row>
            </div>
          }
        </div>
      )
    }

    render() {
    	const { provider, closePage, user } = this.props;
        const { handleSubmit, pristine, submitting, submitSucceeded } = this.props;

    	return (
            <div>
                <form role="form" autoComplete="none">
                    <div className="provider-bloc-form">
                        <Row>
                            <Col>
                                <div className="title"> Informations société </div>
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                              <Field
                                name="company"
                                component={renderInputUpperCase}
                                validate={isRequired}
                                label="Raison sociale*" />
                            </Col>
                          </Row>

                          <Row>
                              <Col>
                                <Field
                                  name="address"
                                  component={renderInputUpperCase}
                                  validate={isRequired}
                                  label="Adresse*" />
                              </Col>
                          </Row>

                          <Row>
                              <Col>
                                <Field
                                  name="additional_address"
                                  component={renderInputUpperCase}
                                  label="Complement adresse" />
                              </Col>
                          </Row>

                          <Row>
                              <Col>
                                <Field
                                  name="zip"
                                  component={renderInput}
                                  validate={[isRequired, maxLength(5)]}
                                  label="Code Postal*" />
                              </Col>
                              <Col>
                                <Field
                                  name="city"
                                  component={renderInputUpperCase}
                                  validate={isRequired}
                                  label="Ville*" />
                              </Col>
                          </Row>

                          <Row>
                              <Col>
                                <Field
                                  name="legal_form"
                                  component={renderSelect}
                                  validate={isRequired}
                                  options={[
                                    {id:"Entreprise Individuelle", name:"Entreprise Individuelle"},
                                    {id:"Micro Entreprise", name:"Micro Entreprise"},
                                    {id:"SA", name:"SA"},
                                    {id:"SARL", name:"SARL"},
                                    {id:"SAS", name:"SAS"},
                                    {id:"EIRL", name:"EIRL"},
                                    {id:"EURL", name:"EURL"}
                                  ]}
                                  label="Forme Juridique*" />
                              </Col>
                          </Row>

                          <Row>
                              {this.state.responsive &&
                                <Col xs="12">
                                  <Label>Date de creation de l'entreprise*</Label>
                                </Col>
                              }
                               <Col>
                                <Field
                                  name="date_company_day"
                                  component={renderSelect}
                                  options={this.state.day}
                                  label={!this.state.responsive ? "Date de creation de l'entreprise*" : null} />
                              </Col>
                              <Col>
                                <Field
                                  name="date_company_month"
                                  component={renderSelect}
                                  options={[
                                    {id:"01", name:"Janvier"},
                                    {id:"02", name:"Février"},
                                    {id:"03", name:"Mars"},
                                    {id:"04", name:"Avril"},
                                    {id:"05", name:"Mai"},
                                    {id:"06", name:"Juin"},
                                    {id:"07", name:"Juillet"},
                                    {id:"08", name:"Aout"},
                                    {id:"09", name:"Septembre"},
                                    {id:"10", name:"Octobre"},
                                    {id:"11", name:"Novembre"},
                                    {id:"12", name:"Décembre"},
                                  ]}/>
                              </Col>
                              <Col>
                                <Field
                                  name="date_company_year"
                                  component={renderSelect}
                                  options={this.state.year}/>
                              </Col>
                          </Row>

                          <Row>
                              <Col>
                                <Field
                                  name="siret"
                                  // type="number"
                                  component={renderInput}
                                  validate={exactLength(14)}
                                  maxlength="14"
                                  label="SIRET"
                                  autoComplete="none" />
                              </Col>
                          </Row>

                          <Row>
                              <Col>
                                  <FormGroup className="input-radio">
                                      <Label>Etes-vous exonéré de TVA ?</Label>
                                      <FormGroup check>
                                          <Field
                                            name="tva"
                                            type="radio"
                                            component={renderRadio}
                                            value="False"
                                            label="Non" />
                                            <Field
                                            name="tva"
                                            type="radio"
                                            value="True"
                                            component={renderRadio}
                                            label="Oui" />
                                      </FormGroup>
                                  </FormGroup>
                              </Col>
                          </Row>

                          {user.role !== "provider" &&
                            <Row>
                                <Col>
                                  <Field
                                    name="code_provider"
                                    component={renderInput}
                                    label="Code Prestataire" />
                                </Col>
                            </Row>
                          }

                          {!this.props.create && user.role !== "provider" &&
                            this.renderContact("plateau", "Plateau")
                          }

                          {!this.props.create && user.role !== "provider" &&
                            this.renderContact("acf", "ACF")
                          }

                          {!this.props.create && user.role !== "provider" &&
                            this.renderContact("reseau" , "Réseau")
                          }

                          {!this.props.create && user.role !== "provider" &&
                            this.renderContact("bill", "Facturation")
                          }

                    </div>

                    <div>
                     <Row className="form-btn">

                        {this.props.create &&
                          <Col className="center">

                              <FormGroup>
                                  <Button className="btn-transparent" onClick={() => { this.props.previousPage(); window.scrollTo(0, 0)} }>Etape précédente</Button>

                                  {submitting &&
                                    <ButtonLoader />
                                  ||
                                   <Button className="btn-green" onClick={handleSubmit}>Etape suivante</Button>
                                  }

                            </FormGroup>
                          </Col>
                        }

                        {!this.props.create &&
                          <Col className="center">
                              <FormGroup>
                                <Button className="btn-transparent" onClick={closePage}>{submitSucceeded && "Retour à la fiche" || "Annuler"}</Button>

                                {submitting &&
                                  <ButtonLoader />
                                ||
                                  <Button className="btn-green" onClick={handleSubmit} >Enregistrer</Button>
                                }
                            </FormGroup>
                          </Col>
                        }


                      </Row>
                    </div>

                    <div className="provider-bloc-note">
                        * Champs obligatoires
                    </div>
                    <div className="provider-bloc-note">
                        Les informations recueillies sont nécessaires à HomeServe pour la gestion de votre candidature à notre réseau de prestataires agréé grâce à la création de votre compte prestataire.
                        Pour plus d’informations, consultez notre <a href={"https://homeserve.fr/politique-protection-donnees-personnelles"}> Politique de données personnelles. </a>
                        Conformément à la règlementation, vous bénéficiez d’un droit d’accès, de rectification, de limitation, de portabilité, d’effacement et d’opposition à l’utilisation de vos données personnelles ainsi que du droit de formuler des directives concernant la gestion de vos données post mortem.
                        Vous pouvez exercer ces droits en vous adressant auprès de HomeServe – Service Clients – TSA 82111 – 69303 Lyon Cedex 07 ou par mail à webmestre@homeserve.fr
                    </div>
                </form>
            </div>
        )
    }
}


export default FormStepTwo



// WEBPACK FOOTER //
// ./src/provider/components/FormStepTwo.js